var map = {
	"./24_7.png": 574,
	"./Accounting.png": 2087,
	"./Brokerage.png": 5222,
	"./Carriers.png": 3714,
	"./Chat.png": 2467,
	"./CheckPrinting.png": 6536,
	"./Compliance.png": 9142,
	"./Compliance1.png": 7086,
	"./CustomDocuments.png": 3273,
	"./EldIntegration.png": 4732,
	"./Forcasting.png": 3667,
	"./GPSTracking.png": 791,
	"./Integration.png": 3402,
	"./LoadTracking.png": 4585,
	"./Loadpayment.png": 961,
	"./MobileService.png": 8444,
	"./Notification.png": 2279,
	"./Onboarding.png": 5738,
	"./Oneclick.png": 3316,
	"./Quick Invoice-22.png": 9395,
	"./Recruiting.png": 718,
	"./Reports.png": 6415,
	"./Sharelive.png": 5049,
	"./Storage.png": 8614,
	"./TMS.png": 2364,
	"./Unlimited.png": 2764
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5078;